import cloneDeep from 'clone-deep'
import { CustomFieldType, getFieldOriginOptions } from 'config/loan.input.fields.constants'
import { FieldOrigin, IVisibleLogic } from 'config/loan.input.visibility.type'

export interface IBorrowerLoanWorkflowBase {
  title: string
  headerText?: string
  tooltip?: string
  required?: boolean
  visibleLogic?: IVisibleLogic[][]
}

export const getFieldOriginOptionsExceptCustom = () => {
  const options = cloneDeep(getFieldOriginOptions())
  delete (options as any)[FieldOrigin.Custom]
  return options
}

export interface ISelectOption {
  key: string
  mapTo?: string
  title: string
  visible: boolean
  isCustom: boolean
  [key: string]: any
}

export interface IBorrowerLoanWorkflowSelect extends IBorrowerLoanWorkflowInput {
  type: 'select'
  options: ISelectOption[]
  // visibility: Record<string, boolean> // Visibility for each options
}

export interface ILinkToPartyValue {
  isActive: boolean
  type: string
  input: string
}

export interface IBorrowerLoanWorkflowInput extends IBorrowerLoanWorkflowBase {
  fieldOrigin: FieldOrigin
  fieldKey: string
  linkToParty?: ILinkToPartyValue
}

export interface IBorrowerLoanWorkflowCustomInput extends IBorrowerLoanWorkflowInput {
  fieldOrigin: FieldOrigin.Custom
  fieldType: CustomFieldType
  linkedFieldOrigin?: FieldOrigin
  linkedFieldKey?: string
}

export interface IBorrowerLoanWorkflowCustomInputText extends IBorrowerLoanWorkflowCustomInput {
  fieldType:
    | CustomFieldType.Text
    | CustomFieldType.Date
    | CustomFieldType.Number
    | CustomFieldType.ThousandSepWithDoller
    | CustomFieldType.Percentage
    | CustomFieldType.Email
    | CustomFieldType.Phone
    | CustomFieldType.Ssn
    | CustomFieldType.TextArea
    | CustomFieldType.URL
}

export interface IBorrowerLoanWorkflowCustomInputSelect extends IBorrowerLoanWorkflowCustomInput {
  fieldType: CustomFieldType.Select
  options: ISelectOption[]
  // visibility: Record<string, boolean> // Visibility for each options
}

export interface IBorrowerLoanWorkflowCustomInputToggle extends IBorrowerLoanWorkflowCustomInput {
  fieldType: CustomFieldType.Toggle
}

export type IBorrowerLoanWorkflowCustomInputs =
  | IBorrowerLoanWorkflowCustomInputText
  | IBorrowerLoanWorkflowCustomInputSelect
  | IBorrowerLoanWorkflowCustomInputToggle

export type IBorrowerLoanWorkflowControl =
  | IBorrowerLoanWorkflowSelect
  | IBorrowerLoanWorkflowInput
  | IBorrowerLoanWorkflowCustomInputs

export interface IBorrowerLoanWorkflowForm extends IBorrowerLoanWorkflowBase {
  type: 'form'
  inputs: IBorrowerLoanWorkflowControl[]
}

export type IBorrowerLoanWorkflowStep = IBorrowerLoanWorkflowSelect | IBorrowerLoanWorkflowForm

export interface IBorrowerLoanWorkflowBaseData {
  [key: string]: Record<string, string>
}
